module.exports = __webpack_public_path__ + "static/media/logo.284daf70.png";